module.exports = __webpack_public_path__ + "flyer_background_candy_hearts_132-630652ec1c2f4bbf0ec48d1eaac0cf9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_candy_hearts_132.jpg
// module id = 1616
// module chunks = 1